module.exports = __webpack_public_path__ + "media/images/illustrations/united-states-268dc4934c4671d7b373cbe1e5939d5e.svg";